import { useTranslation } from "react-i18next";
import type { TrackerStrategyResultDto } from "../../api/hooks/usePortfolioTracker";

/** What a strategy's trades came to: "3 won · 1 lost · 1 open". */
export function useTradeTally() {
  const { t } = useTranslation("portfolioTracker");
  return (strategy: TrackerStrategyResultDto) => {
    const unpriced = strategy.trades.filter((trade) => trade.returnPercent === null).length;
    return [
      t("tally.wonLost", { won: strategy.won, lost: strategy.lost }),
      strategy.openTrade ? t("tally.open", { count: 1 }) : null,
      unpriced ? t("tally.unpriced", { count: unpriced }) : null,
    ]
      .filter(Boolean)
      .join(" · ");
  };
}
